module.exports = __webpack_public_path__ + "static/media/guojimaoyi1.73f21330.png";